import React, { lazy, Suspense } from 'react';
import './Contact.css';
import { getStoredData } from "../../json/fetchData.js";

// ✅ Lazy load the components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ContactUsForm = lazy(() => import("../../components/ContactUsForm/ContactUsForm.js"));
const OfficeMapDetails = lazy(() => import('../../components/ContactOfficeDetails/ContactOfficeDetails.js'));

const Contact = () => {
  const totalData = getStoredData();
  const data = totalData[26];

  return (
    <div>
      {/* ✅ Wrap lazy-loaded components in Suspense */}
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate image={data.Image} title={data.Title} page={totalData[0]} />
      </Suspense>
      
      <Suspense fallback={<p>Loading contact form...</p>}>
        <ContactUsForm data={data.ContactContent} />
      </Suspense>

      <Suspense fallback={<p>Loading office map details...</p>}>
        <OfficeMapDetails data={data.ContactMap} />
      </Suspense>
    </div>
  );
};

export default Contact;
